const RejectIcon = ({
  height = "40px",
  width = "40px",
}: {
  height?: string;
  width?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: `${width}`, height: `${height}` }} // Use inline styles here
      viewBox="0 0 40 40"
      fill="none"
    >
      <g clipPath="url(#clip0_334_19371)">
        <path
          d="M32.5 40H7.5C3.35754 40 0 36.6425 0 32.5V7.5C0 3.35754 3.35754 0 7.5 0H32.5C36.6425 0 40 3.35754 40 7.5V32.5C40 36.6425 36.6425 40 32.5 40Z"
          fill="#FFF1F0"
        />
        <path
          d="M20 10C14.4864 10 10 14.4864 10 20C10 25.5136 14.4864 30 20 30C25.5136 30 30 25.5136 30 20C30 14.4864 25.5136 10 20 10ZM23.6826 22.5049C24.0076 22.8299 24.0076 23.3575 23.6826 23.6838C23.5199 23.8461 23.3063 23.9276 23.0939 23.9276C22.8812 23.9276 22.6675 23.8461 22.5049 23.6838L20 21.1789L17.4951 23.6838C17.3325 23.8461 17.1188 23.9276 16.9061 23.9276C16.6925 23.9276 16.4801 23.8461 16.3174 23.6838C15.9924 23.3588 15.9924 22.8311 16.3174 22.5049L18.8211 20L16.3162 17.4951C15.9912 17.1701 15.9912 16.6425 16.3162 16.3162C16.6412 15.99 17.1689 15.9912 17.4951 16.3162L20 18.8211L22.5049 16.3162C22.8299 15.9912 23.3575 15.9912 23.6838 16.3162C24.01 16.6412 24.0088 17.1689 23.6838 17.4951L21.1789 20L23.6826 22.5049Z"
          fill="#E62D38"
        />
      </g>
      <defs>
        <clipPath id="clip0_334_19371">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default RejectIcon;
